import React from 'react';
import { Organization } from '../../../../types/organization.types';
import { DataField } from './DataField';
import { FieldGrid, SectionCard, SectionLabel, TagList } from './SectionComponents';

interface AIAssistantSectionProps {
  selectedOrg: Organization;
  onboardingSetup: any;
  onboardingData: any;
  asTab?: boolean;
}

export const AIAssistantSection: React.FC<AIAssistantSectionProps> = ({ onboardingData }) => {
  const twilioData = onboardingData.twilio;

  if (!twilioData) {
    return <p className="text-gray-500 dark:text-gray-400 text-sm">No Twilio data available</p>;
  }

  const businessAddress = twilioData.business_address;
  const formattedAddress = businessAddress
    ? `${businessAddress.street || ''}, ${businessAddress.city || ''}, ${businessAddress.state || ''} ${businessAddress.zip || ''}${businessAddress.country ? `, ${businessAddress.country}` : ''}`
    : undefined;

  return (
    <div className="space-y-4">
      {/* Phone Number Preferences */}
      <SectionCard title="Phone Number Preferences">
        <FieldGrid>
          <DataField label="Preferred Area Code" value={twilioData.preferred_area_code} />
          <DataField label="Preferred Location" value={twilioData.preferred_location} />
        </FieldGrid>
        {twilioData.other_area_codes?.length > 0 && (
          <div className="mt-4">
            <SectionLabel>Other Acceptable Area Codes</SectionLabel>
            <TagList items={twilioData.other_area_codes} />
          </div>
        )}
      </SectionCard>

      {/* Business Verification */}
      <SectionCard title="Business Verification">
        <FieldGrid>
          <DataField label="Legal Business Name" value={twilioData.legal_business_name} />
          <DataField label="Business Type" value={twilioData.business_type} />
          <DataField label="EIN / CBN" value={twilioData.ein_cbn} />
          <DataField label="Business Website" value={twilioData.business_website} type="link" />
        </FieldGrid>
        {formattedAddress && (
          <div className="mt-4">
            <DataField label="Business Address" value={formattedAddress} />
          </div>
        )}
      </SectionCard>
    </div>
  );
};
